import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Slider} from '@js/components/Slider'
import {Archive} from '@js/components/Archive'
import {Mask} from '@js/animations/Mask'
import {Stagger} from '@js/animations/Stagger'
import {Wipe} from '@js/animations/Wipe'
import {Scroll} from '@js/animations/Scroll'
import {Translate} from '@js/animations/Translate'
import {Shape} from '@js/animations/Shape'
import {Zoom} from '@js/animations/Zoom'
import Timeline from "@js/components/Timeline";
import Cards from "@js/components/Cards";
import SlideCard from "@js/components/SlideCard";
import Tabs from "@js/components/Tabs";
import ScrollDown from "@js/components/ScrollDown";

window.onload = () => {

  const animations = [
    Mask,
    Stagger,
    Wipe,
    Scroll,
    Translate,
    Shape,
    Zoom
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Header()
  new Archive()
  new Slider()
  new Timeline()
  new Cards()
  new SlideCard()
  new Tabs()
  new ScrollDown()

}
